import { PocProgressSpinner } from 'commons/components/components-wrapper/poc-progress-spinner.component';
import { DeviceConfigurationInstance } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-configuration-layout/settings-devices-configuration-layout.model';
import { DeviceConfigurationInfo } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-configuration-list/settings-devices-configuration-list.model';
import { LAYOUT_WORKFLOW_TABS } from '../constants';
import { SettingsConfigurationContent } from '../settings-devices-configuration.style';
import { DeviceConfigurationForm } from './device-configuration-form.component';
import { DeviceConfigurationProperties } from './device-configuration-properties.component';

export interface DeviceConfigurationContentProps {
    deviceConfigurationInstance: DeviceConfigurationInstance;
    selectedTab: string;
    onConfigurationChange: <K extends keyof DeviceConfigurationInfo>(
        propertyName: K,
        value: DeviceConfigurationInfo[K]
    ) => void;
}

export const DeviceConfigurationContent: React.FC<DeviceConfigurationContentProps> = ({
    deviceConfigurationInstance,
    selectedTab,
    onConfigurationChange,
}) => (
    <SettingsConfigurationContent>
        {deviceConfigurationInstance.id ? (
            <div>
                {selectedTab === LAYOUT_WORKFLOW_TABS.CONFIG && (
                    <DeviceConfigurationForm
                        deviceConfigurationInstance={deviceConfigurationInstance}
                        onConfigurationChange={onConfigurationChange}
                    />
                )}

                {selectedTab === LAYOUT_WORKFLOW_TABS.DEVICE_PROPERTIES && <DeviceConfigurationProperties />}
            </div>
        ) : (
            <PocProgressSpinner />
        )}
    </SettingsConfigurationContent>
);
